export default "__VITE_ASSET__DcSS1jdH__"